import React, { useState } from "react";
import { Spin2, Button } from "components";

import "./index.scss";

const InitialImage = ({ image, onChange, onDelete }) => {
  const { cdn_url, name } = image;

  const [loading, setLoading] = useState(true);

  return (
    <>
      <div className="builder-initial-image">
        <img
          onLoad={() => setLoading(false)}
          style={{
            display: loading ? 'none' : 'block',
          }}
          src={cdn_url}
          alt={name}
        />

          <div style={{ display: loading ? 'block' : 'none', position: "absolute" }}>
              <Spin2 black />
          </div>
      </div>

      <div className="d-flex justify-content-between mt-3">
        <Button variant="warning" size="large" className="text-nowrap mr-2" onClick={onDelete}>
          Remove image
        </Button>

        <Button size="large" className="text-nowrap" onClick={() => onChange(image)}>
          Change image
        </Button>
      </div>
    </>
  );
};

export default InitialImage;
